import { Directive, Input } from '@angular/core';
import { ITicketMessage } from '../../models';

@Directive()
export abstract class MessageLabelBaseComponent {
  @Input() message: ITicketMessage;
}
